<template>
  <div class="breadcrumbs-skeleton">
    <PageWrap>
      <SkeletonItem
        class="breadcrumbs-skeleton__item"
        height="47.5px"
        :border-radius="8"
        :is-animated="animated"
        ignore-global-animation
      />
    </PageWrap>
  </div>
</template>

<script setup lang="ts">
  import { SkeletonItem } from '@experience/core-skeleton-lib';

  import PageWrap from '@/shared/ui/PageWrap.vue';

  withDefaults(
    defineProps<{
      animated?: boolean;
    }>(),
    {
      animated: true,
    },
  );
</script>

<style scoped lang="scss">
  .breadcrumbs-skeleton {
    margin-bottom: 32px;

    @include mobile {
      margin-top: 12px;
      margin-bottom: 32px;
    }
  }

  .breadcrumbs-skeleton__item {
    width: 460px;
    max-width: 100%;

    @include mobile {
      width: 230px;
    }
  }
</style>
